import { TONES, type Tone } from "../../../../lib/home-mock";

// Persian calendar, Tehran time: «۲۱ مهر».
const DAY_MONTH = new Intl.DateTimeFormat("fa-IR", { day: "numeric", month: "long", timeZone: "Asia/Tehran" });

const FULL_DATE = new Intl.DateTimeFormat("fa-IR", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Tehran" });

export function formatPostDate(iso: string | null): string {
  return iso ? DAY_MONTH.format(new Date(iso)) : "";
}

/** With the year, for a post's own header: «۲۱ مهر ۱۴۰۵». */
export function formatPostDateFull(iso: string | null): string {
  return iso ? FULL_DATE.format(new Date(iso)) : "";
}

export const faNumber = (n: number) => n.toLocaleString("fa-IR");

/** A category keeps one tone everywhere on the blog (its chip, shelf, cards
 *  and page header), picked by its position in the editors' order, so readers
 *  learn the colors. Unlike the home bento, these don't shuffle per load. */
export function categoryTone(index: number): Tone {
  return TONES[((index % TONES.length) + TONES.length) % TONES.length]!;
}
